<template>
  <div
    id="user-search-bar"
  >
    <a-select
      v-model:value="selectedUserId"
      show-search
      :placeholder="$t('layout.header.searchPlaceholder')"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="isLoading ? undefined : null"
      :get-popup-container="triggerNode => triggerNode.parentNode"
      :style="{ width: '400px' }"
      @search="search"
      @select="onSelect"
    >
      <template
        v-if="isLoading"
        #notFoundContent
      >
        <a-spin size="small" />
      </template>
      <a-select-option
        v-for="user in users"
        :key="user.uid"
        :value="user.uid"
      >
        <AlignUser :user="user" />
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'

import useSearchUser from '@/composables/use-search-user'
import AlignUser from '@/components/AlignDialog/AlignUser'

export default {
  components: {
    AlignUser
  },
  setup () {
    const router = useRouter()
    const {
      isLoading,
      users,
      search
    } = useSearchUser()
    const selectedUserId = ref(null)

    function onSelect (id) {
      router.push({
        name: 'UserOkr',
        params: {
          userId: id
        }
      })
      nextTick(() => {
        selectedUserId.value = null
      })
    }

    return {
      isLoading,
      users,
      search,
      onSelect,
      selectedUserId
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-select-selector) {
  border-radius: 16px !important;
}
</style>
